import React, { useState, useEffect, useContext } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Paper, Tab, Tabs, Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import { MdAdd } from 'react-icons/md';
import { getEngagementByClientIdApi } from "../../api's/EngagementApi";
import { getWorkflowByClientIdApi } from "../../api's/WorkflowApi";
import { CLIENT_PAGE, ENGAGEMENT_PAGE, WORKFLOW_PAGE } from '../../utils/commonConstants';
import SearchAndFilter from '../../reusable-component/SearchAndFilter';
import EngagementTable from '../../components/Client/EngagementTable';
import ClientNoData from '../../components/Client/ClientNoData';
import WorkflowTable from '../../components/Client/WorkflowTable';
import AddEngagementModal from '../../reusable-component/AddEngagementModal';
import PageHeaderTable from '../../reusable-component/PageHeaderTable';
import AddWorkflowModal from '../../reusable-component/AddWorkflowModal';
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { AuthContext } from '../../context/AuthProvider';
import AccessModal from '../../reusable-component/AccessModal';
import useDebounce from '../../hooks/useDebounce';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ClientDetails({ headerTableData }) {
  const [mode, setMode] = useState('');
  const [status, setStatus] = useState(() => {
    const storedValue = sessionStorage.getItem('filtered_clientdetails_status');
    return storedValue !== null ? storedValue : '';
  });
  const [search, setSearch] = useState(() => {
    const storedValue = sessionStorage.getItem('filtered_clientdetails_search');
    return storedValue !== null ? storedValue : '';
  });
  const [status1, setStatus1] = useState(() => {
    const storedValue = sessionStorage.getItem('filtered_clientdetails_status1');
    return storedValue !== null ? storedValue : '';
  });
  const [search1, setSearch1] = useState(() => {
    const storedValue = sessionStorage.getItem('filtered_clientdetails_search1');
    return storedValue !== null ? storedValue : '';
  });
  const [value, setValue] = useState(() => {
    const storedValue = sessionStorage.getItem('tab_value_clientDetails');
    return storedValue !== null ? parseInt(storedValue, 10) : 0;
  });
  const [tableData, setTableData] = useState([]);
  const [workflowTableData, setWorkflowTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [filteredWorkflowTableData, setFilteredWorkflowTableData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openWorkflowModal, setOpenWorkflowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalText, setTotalText] = useState(0);
  const [totalWorkflowCount, setTotalWorkflowCount] = useState(0);
  const [totalWorkflowText, setTotalWorkflowText] = useState(0);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const { domainName } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const rowsPerPage = 5;
  const debouncedSearch = useDebounce(search, 500);
  const debouncedWorkflowSearch = useDebounce(search1, 500);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleWorkflowModal = () => {
    setOpenWorkflowModal(!openWorkflowModal);
  };

  const handleSearch = () => {
    console.log('Hii');
  };

  const handleMode = (event) => {
    setMode(event.target.value);
  };

  const handleStatus = (event) => {
    if (value === 0) {
      sessionStorage.setItem('filtered_clientdetails_status', event.target.value);
      setStatus(event.target.value);
      setPage(0);
    } else if (value === 1) {
      sessionStorage.setItem('filtered_clientdetails_status1', event.target.value);
      setStatus1(event.target.value);
      setPage(0);
    }
  };

  const handleOnChange = (event) => {
    if (value === 0) {
      sessionStorage.setItem('filtered_clientdetails_search', event.target.value);
      setSearch(event.target.value);
      setPage(0);
    } else if (value === 1) {
      sessionStorage.setItem('filtered_clientdetails_search1', event.target.value);
      setSearch1(event.target.value);
      setPage(0);
    }
  };

  const handleClearFilter = () => {
    sessionStorage.removeItem('filtered_clientdetails_status');
    sessionStorage.removeItem('filtered_clientdetails_search');
    sessionStorage.removeItem('filtered_clientdetails_status1');
    sessionStorage.removeItem('filtered_clientdetails_search1');
    setMode('');
    setStatus('');
    setSearch('');
    setStatus1('');
    setSearch1('');
    setPage(0);
  };

  const handleAccessModal = () => {
    setOpenAccessModal(!openAccessModal);
  };

  const fetchFilterTableData = (responseTableData) => {
    const filtered_status = sessionStorage.getItem('filtered_clientdetails_status') || '';
    const filtered_search = sessionStorage.getItem('filtered_clientdetails_search') || '';
    const filtered_search_lowercase = filtered_search.toLowerCase() || '';
    if (filtered_status !== '' || filtered_search !== '') {
      const result_exist =
        filtered_status && filtered_search
          ? responseTableData.filter(
              (data) =>
                data.status === filtered_status &&
                data.engagement_name.toLowerCase().startsWith(filtered_search_lowercase)
            )
          : filtered_status
          ? responseTableData.filter((data) => data.status === filtered_status)
          : filtered_search
          ? responseTableData.filter((data) => data.engagement_name.toLowerCase().startsWith(filtered_search_lowercase))
          : null;

      setFilteredTableData(result_exist);
    } else {
      setFilteredTableData(responseTableData);
    }
    setPage(0);
  };

  const fetchTableData = async (pageNo = page) => {
    setLoading(true);

    try {
      const response = await getEngagementByClientIdApi(
        headerTableData.client_id,
        pageNo,
        rowsPerPage,
        debouncedSearch,
        status
      );

      if (response.status === 200) {
        setTableData(response.data.data);
        if (search === '' && status === '') setTotalText(response.data.totalData);
        setTotalCount(response.data.totalData);
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Engagement not found!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        setTableData([]);
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!headerTableData?.client_id) return;
    fetchTableData(0);
  }, [headerTableData?.client_id]);

  useEffect(() => {
    fetchWorkflowTableData();
  }, []);

  useEffect(() => {
    if (!headerTableData?.client_id) return;
    if (value !== 0) return;
    fetchTableData(page);
  }, [page, debouncedSearch, status]);

  useEffect(() => {
    if (value !== 1) return;
    fetchWorkflowTableData(page);
  }, [page, debouncedWorkflowSearch, status1, value]);

  const filtered_status = sessionStorage.getItem('filtered_clientdetails_status') || '';
  const filtered_search = sessionStorage.getItem('filtered_clientdetails_search') || '';

  const filtered_status1 = sessionStorage.getItem('filtered_clientdetails_status1') || '';
  const filtered_search1 = sessionStorage.getItem('filtered_clientdetails_search1') || '';

  useEffect(() => {
    if (filtered_status !== '' || filtered_search !== '') {
      fetchFilterTableData(tableData);
    } else {
      setFilteredTableData(tableData);
    }
  }, [search, status]);

  useEffect(() => {
    if (filtered_status1 !== '' || filtered_search1 !== '') {
      fetchFilterWorkflowTableData(workflowTableData);
    } else {
      setFilteredWorkflowTableData(workflowTableData);
    }
  }, [search1, status1]);

  const fetchFilterWorkflowTableData = (responseTableData) => {
    const filtered_status = sessionStorage.getItem('filtered_clientdetails_status1') || '';
    const filtered_search = sessionStorage.getItem('filtered_clientdetails_search1') || '';
    const filtered_search_lowercase = filtered_search.toLowerCase() || '';
    if (filtered_status !== '' || filtered_search !== '') {
      const result_exist =
        filtered_status && filtered_search
          ? responseTableData.filter(
              (data) =>
                data.status === filtered_status &&
                data.workflow_name.toLowerCase().startsWith(filtered_search_lowercase)
            )
          : filtered_status
          ? responseTableData.filter((data) => data.status === filtered_status)
          : filtered_search
          ? responseTableData.filter((data) => data.workflow_name.toLowerCase().startsWith(filtered_search_lowercase))
          : null;
      setFilteredWorkflowTableData(result_exist);
    } else {
      setFilteredWorkflowTableData(responseTableData);
    }
    setPage(0);
  };

  const version = JSON.parse(sessionStorage.getItem('version'));

  const fetchWorkflowTableData = async (pageNo = page) => {
    if (!headerTableData?.client_id) return;

    setLoading(true);
    try {
      const response = await getWorkflowByClientIdApi(
        headerTableData.client_id,
        pageNo,
        rowsPerPage,
        debouncedWorkflowSearch,
        status1
      );

      if (response.status === 200) {
        setWorkflowTableData(response.data.data);
        setFilteredWorkflowTableData(response.data.data);
        if (debouncedWorkflowSearch === '' && status1 === '') setTotalWorkflowText(response.data.totalData);
        setTotalWorkflowCount(response.data.totalData);
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', { variant: 'error' });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Workflow not found!', { variant: 'error' });
        setWorkflowTableData([]);
        setFilteredWorkflowTableData([]);
      } else {
        enqueueSnackbar('Something went wrong!', { variant: 'error' });
      }
    } finally {
      setLoading(false);
    }
  };

  const Grid = styled(MuiGrid)(({ theme }) => ({
    width: '100%',
    ...theme.typography.body1,
    '& [role="separator"]': {
      margin: theme.spacing(0, 2),
    },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem('tab_value_clientDetails', newValue.toString());
    if (newValue === 0) {
      sessionStorage.removeItem('filtered_clientdetails_status1');
      sessionStorage.removeItem('filtered_clientdetails_search1');
      setFilteredTableData(tableData);
    } else if (newValue === 1) {
      sessionStorage.removeItem('filtered_clientdetails_status');
      sessionStorage.removeItem('filtered_clientdetails_search');
      setFilteredWorkflowTableData(workflowTableData);
    }
    setMode('');
    setStatus('');
    setSearch('');
    setStatus1('');
    setSearch1('');
  };

  const data = {
    search: value === 0 ? search : search1,
    handleSearch,
    handleOnChange,
    region: mode,
    handleRegion: handleMode,
    handleClearFilter,
    handleStatus,
    status: value === 0 ? status : status1,
    firstFilterText: ENGAGEMENT_PAGE.engagementFilterByMode,
    secondFilterText: CLIENT_PAGE.clientFilterByStatus,
    clearFilterText: CLIENT_PAGE.clientClearFilterButton,
    firstFilterValues: {
      first: 'Real Time',
      second: 'Batch',
    },
    secondFilterValues: {
      filterData: ['approved', 'pending'],
    },
    // isFirstFilterVisible: value === 1,
    isFirstFilterVisible: false,
    isSecondFilterVisible: true,
  };

  const headerData = {
    firstHeader: 'CLIENT',
    secondHeader: 'REGION',
    thirdHeader: 'TOTAL ENGAGEMENTS',
    fourthHeader: 'TOTAL WORKFLOWS',
    fifthHeader: 'CREATED BY',
    sixthHeader: 'CREATED ON',
    seventhHeader: 'STATUS',
    firstHeaderText: headerTableData.client_name,
    secondHeaderText: headerTableData.region,
    thirdHeaderText: totalText,
    fourthHeaderText: totalWorkflowText,
    fifthHeaderText: headerTableData.created_by,
    sixthHeaderText: headerTableData.created_at,
    seventhHeaderText: headerTableData.status,
    domainName,
    route: '/client',
  };

  return (
    <Box>
      <PageHeaderTable data={headerData} />
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 1.5,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#47D7AC',
            },
          }}
          sx={{ '& .MuiTab-root.Mui-selected': { color: '#00043C' } }}
        >
          <Tab label={`Engagements(${totalCount})`} {...a11yProps(0)} sx={{ fontWeight: 'bold' }} />
          <Tab label={`Workflows(${totalWorkflowCount})`} {...a11yProps(1)} sx={{ fontWeight: 'bold' }} />
        </Tabs>
      </Box>
      <Box>
        <TabPanel value={value} index={0}>
          <Grid container direction="row" display="flex">
            <Grid item xs={6} direction="row" justifyContent="flex-start" style={{ color: '#43425D' }}>
              {ENGAGEMENT_PAGE.engagementPageTitle}
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: '#00043C', '&:hover': { backgroundColor: '#00043C' } }}
                onClick={handleOpenModal}
              >
                <MdAdd />
                {ENGAGEMENT_PAGE.addNewEngagementButton}
              </Button>
            </Grid>
          </Grid>
          <SearchAndFilter data={data} />
          {tableData.length !== 0 ? (
            <EngagementTable
              totalCount={totalCount}
              tableData={tableData}
              fetchTableData={fetchTableData}
              currentPage={page}
              setPage={setPage}
            />
          ) : (
            !loading && (
              <Paper elevation={3} sx={{ height: '350px', marginTop: '15px' }}>
                <ClientNoData
                  title={ENGAGEMENT_PAGE.engagementPageNoDataToDisplay}
                  text={ENGAGEMENT_PAGE.noEngagementToReview}
                  addBtnText={ENGAGEMENT_PAGE.addNewEngagementButton}
                  handleOnClick={handleOpenModal}
                  isAddBtn
                />
              </Paper>
            )
          )}
          {loading && <LoadingIcon />}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid container direction="row" display="flex">
            <Grid item xs={6} direction="row" justifyContent="flex-start" style={{ color: '#43425D' }}>
              {WORKFLOW_PAGE.workflowPageTitle}
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: '#00043C', '&:hover': { backgroundColor: '#00043C' } }}
                onClick={handleWorkflowModal}
              >
                <MdAdd />
                Add New Workflow
              </Button>
            </Grid>
          </Grid>
          <AddWorkflowModal
            handleModal={handleWorkflowModal}
            open={openWorkflowModal}
            fetchTableData={fetchWorkflowTableData}
            processType="Ingestion"
          />
          <SearchAndFilter data={data} />
          {workflowTableData.length !== 0 ? (
            <WorkflowTable
              totalCount={totalWorkflowCount}
              tableData={workflowTableData}
              fetchWorkflowTableData={fetchWorkflowTableData}
              currentPage={page}
              setPage={setPage}
            />
          ) : (
            <Paper elevation={3} sx={{ height: '330px', marginTop: '10px' }}>
              <ClientNoData
                title={WORKFLOW_PAGE.workflowPageNoDataToDisplay}
                text={WORKFLOW_PAGE.noWorkflowToReview}
                addBtnText={WORKFLOW_PAGE.addNewWorkflowButton}
                handleOnClick={handleWorkflowModal}
                isAddBtn
              />
            </Paper>
          )}
          {loading && <LoadingIcon />}
        </TabPanel>
        <AddEngagementModal handleCloseModal={handleCloseModal} openModal={openModal} fetchData={fetchTableData} />
        <AccessModal openAccessModal={openAccessModal} handleAccessModal={handleAccessModal} />
      </Box>
    </Box>
  );
}
